import React from 'react';
import { Box, Typography, Paper, styled } from '@mui/material';
import { format, parseISO, eachHourOfInterval, startOfDay, endOfDay } from 'date-fns';
import { eventTypeGradients } from './styles/eventStyles';

const DayViewContainer = styled(Paper)(({ theme }) => ({
  background: 'rgba(18, 18, 18, 0.95)',
  borderRadius: theme.spacing(2),
  padding: theme.spacing(2),
  height: 'calc(100vh - 300px)',
  overflow: 'auto'
}));

const TimeSlot = styled(Box)(({ theme }) => ({
  display: 'flex',
  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  minHeight: '60px',
  position: 'relative'
}));

const DayView = ({ events, currentDate }) => {
  const hours = eachHourOfInterval({
    start: startOfDay(currentDate),
    end: endOfDay(currentDate)
  });

  return (
    <DayViewContainer>
      {hours.map((hour) => (
        <TimeSlot key={hour.toString()}>
          <Box sx={{ width: '60px', p: 1, borderRight: '1px solid rgba(255, 255, 255, 0.1)' }}>
            <Typography sx={{ color: '#fff' }}>
              {format(hour, 'HH:mm')}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, p: 1 }}>
            {events
              .filter(event => {
                const eventStart = parseISO(event.startDate);
                return format(eventStart, 'yyyy-MM-dd HH') === format(hour, 'yyyy-MM-dd HH');
              })
              .map((event) => (
                <Box
                  key={event.id}
                  sx={{
                    background: eventTypeGradients[event.type].gradient,
                    p: 1,
                    borderRadius: '4px',
                    mb: 1
                  }}
                >
                  <Typography variant="caption" sx={{ color: '#fff' }}>
                    {event.title}
                  </Typography>
                </Box>
              ))}
          </Box>
        </TimeSlot>
      ))}
    </DayViewContainer>
  );
};

export default DayView; 